// Warli SVG figures — white stick-figure-style icons used as stickers.
// Each figure is drawn at a 100x100 viewBox; rendered with currentColor (white).

export const WARLI_FIGURES = [
  {
    id: "dancer",
    name: "Dancer",
    svg: (
      <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="50" cy="22" r="9" fill="currentColor" />
        <line x1="50" y1="31" x2="50" y2="62" />
        <line x1="50" y1="38" x2="28" y2="22" />
        <line x1="50" y1="38" x2="72" y2="22" />
        <line x1="50" y1="62" x2="32" y2="90" />
        <line x1="50" y1="62" x2="68" y2="90" />
      </g>
    ),
  },
  {
    id: "drummer",
    name: "Drummer",
    svg: (
      <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="40" cy="22" r="9" fill="currentColor" />
        <line x1="40" y1="31" x2="40" y2="60" />
        <line x1="40" y1="60" x2="28" y2="90" />
        <line x1="40" y1="60" x2="50" y2="90" />
        <line x1="40" y1="40" x2="58" y2="48" />
        <line x1="40" y1="48" x2="58" y2="60" />
        <circle cx="72" cy="54" r="14" fill="currentColor" />
      </g>
    ),
  },
  {
    id: "hut",
    name: "Hut",
    svg: (
      <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round">
        <polygon points="50,15 18,50 82,50" fill="currentColor" />
        <rect x="22" y="50" width="56" height="38" fill="none" />
        <rect x="42" y="62" width="16" height="26" fill="currentColor" />
      </g>
    ),
  },
  {
    id: "tree",
    name: "Tree",
    svg: (
      <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
        <line x1="50" y1="20" x2="50" y2="90" />
        <line x1="50" y1="40" x2="32" y2="30" />
        <line x1="50" y1="40" x2="68" y2="30" />
        <line x1="50" y1="55" x2="28" y2="48" />
        <line x1="50" y1="55" x2="72" y2="48" />
        <line x1="50" y1="70" x2="34" y2="68" />
        <line x1="50" y1="70" x2="66" y2="68" />
        <circle cx="32" cy="30" r="3" fill="currentColor" />
        <circle cx="68" cy="30" r="3" fill="currentColor" />
        <circle cx="28" cy="48" r="3" fill="currentColor" />
        <circle cx="72" cy="48" r="3" fill="currentColor" />
        <circle cx="34" cy="68" r="3" fill="currentColor" />
        <circle cx="66" cy="68" r="3" fill="currentColor" />
      </g>
    ),
  },
  {
    id: "animal",
    name: "Cow",
    svg: (
      <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <path d="M 22 60 L 22 38 Q 22 32 28 32 L 72 32 Q 78 32 78 38 L 78 60" fill="currentColor" />
        <line x1="28" y1="60" x2="28" y2="84" />
        <line x1="42" y1="60" x2="42" y2="84" />
        <line x1="58" y1="60" x2="58" y2="84" />
        <line x1="72" y1="60" x2="72" y2="84" />
        <line x1="78" y1="34" x2="92" y2="22" />
        <line x1="22" y1="34" x2="14" y2="42" />
        <circle cx="18" cy="30" r="3" fill="currentColor" />
      </g>
    ),
  },
  {
    id: "bird",
    name: "Bird",
    svg: (
      <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <ellipse cx="50" cy="55" rx="22" ry="12" fill="currentColor" />
        <circle cx="72" cy="50" r="7" fill="currentColor" />
        <polygon points="74,46 74,54 92,50" fill="currentColor" />
        <line x1="50" y1="55" x2="30" y2="38" />
        <line x1="50" y1="55" x2="42" y2="40" />
      </g>
    ),
  },
  {
    id: "sun",
    name: "Sun",
    svg: (
      <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
        <circle cx="50" cy="50" r="14" fill="currentColor" />
        {Array.from({ length: 12 }).map((_, i) => {
          const a = (i * Math.PI * 2) / 12;
          const x1 = 50 + Math.cos(a) * 20;
          const y1 = 50 + Math.sin(a) * 20;
          const x2 = 50 + Math.cos(a) * 32;
          const y2 = 50 + Math.sin(a) * 32;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />;
        })}
      </g>
    ),
  },
  {
    id: "human",
    name: "Person",
    svg: (
      <g fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="50" cy="22" r="9" fill="currentColor" />
        <line x1="50" y1="31" x2="50" y2="62" />
        <line x1="50" y1="40" x2="30" y2="50" />
        <line x1="50" y1="40" x2="70" y2="50" />
        <line x1="50" y1="62" x2="38" y2="90" />
        <line x1="50" y1="62" x2="62" y2="90" />
      </g>
    ),
  },
];

export const WARLI_FACTS = [
  {
    title: "What is Warli art?",
    body:
      "Warli is one of the oldest tribal art forms in India. The Warli people of Maharashtra paint stories on the mud walls of their homes — using only circles, triangles, and lines.",
    emoji: "🏡",
  },
  {
    title: "Where does it come from?",
    body:
      "From the Sahyadri hills of Maharashtra. Warli artists have been painting for over 2,500 years — passing the style down from mother to daughter, father to son.",
    emoji: "🌄",
  },
  {
    title: "How is it made?",
    body:
      "The wall is painted with red mud, and the figures are painted on top using a paste made of rice flour and water — with a chewed bamboo stick as the brush!",
    emoji: "🎨",
  },
  {
    title: "What do the figures mean?",
    body:
      "Every drawing tells a story — a wedding, a harvest, a dance, a hunt. The little stick figures show daily village life: people, animals, trees, the sun.",
    emoji: "💃",
  },
];
